module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2n"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("2.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('h2', {
    staticClass: "h2t"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Capital Crimes")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Nine Days Earlier")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "word5"
  }, [_vm._v("BEFORE THE FIELD TRIP, THE")]), _vm._v(" seasickness, and “God Save the Queen.” Before I was looking for a missing teenager, I was trying to find a moon rock. It had been stolen from a safe inside "), _c('span', {
    staticClass: "allcaps"
  }, [_vm._v("NASA")]), _vm._v(" headquarters, just a few blocks south of the "), _c('span', {
    staticClass: "allcaps"
  }, [_vm._v("US")]), _vm._v(" Capitol Building. Despite some significant clues, I was struggling to solve the case. I’d narrowed the list of possible suspects down to two, but the evidence pointed equally at both. That meant one was guilty, one was innocent, and I was stumped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stumped!")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Me? Florian Bates? That’s not supposed to happen. I’m ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("the one they call Young Sherlock. The seventh grader who helped the "), _c('span', {
    staticClass: "allcaps"
  }, [_vm._v("FBI")]), _vm._v(" recover four masterpieces stolen from the National Gallery of Art. The twelve-year-old who figured out how spies were passing secret messages in the doughnut shop across the street from the Russian embassy. (Amazingly, it had to do with where they placed the apple fritters in the display case.)")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I closed my eyes and tried to clear my brain of everything except for the evidence, but it was hard to focus with Margaret staring at me so relentlessly. Even with my eyes shut, I knew that’s what she was doing. Still, just to make sure, I opened the left one ever so slightly to check. That’s when she pounced.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Have you solved it?” she asked eagerly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” I admitted. “But I’m close. Very, very close.” (Detective tip #1: Repetitive adverbs are often a dead giveaway that someone’s lying.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s good,” she said. “Because time’s running out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know that,” I snapped, doing a bad job of hiding my frustration. “Just give me a second.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, but that’s all I can give you because—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Bzzzzzz.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The buzzer sounded and she cackled with glee.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("“Your time’s up and it’s my turn!” She grabbed the dice ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("and began shaking them in her hand. “I am finally going to win this game.”")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She rolled a pair of fours and was deciding which direction to move when Mom arrived with Marcus. We were in the basement room we called the Underground and the doorway was low enough that he had to duck as he entered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’ve got company,” said Mom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, Marcus!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I hope I’m not interrupting.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not at all,” said Margaret. “You’ve arrived just in time to watch me beat Florian.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She moved her token eight spaces and placed it in front of the Supreme Court Building. “Clue card, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s no guarantee she’s going to win,” I told them as I handed her one of the blue cards. “I’m only a turn or two away from solving it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Which is going to make it that much more painful when I beat you.” She jotted something from the card onto her notepad and in true Margaret fashion covered it with her spare hand to keep me from seeing what she was writing.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Marcus tried to make sense of our Frankenstein’s monster of a board game. We’d cobbled it together with buzzers, dice, tokens, and pads raided from other games. A sightseeing map of Washington was taped to a Scrabble board ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("and there were three stacks of index cards marked: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CLUE")]), _vm._v(", "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SUSPECT")]), _vm._v(", and "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EVIDENCE")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you playing?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s called Capital Crimes,” answered Margaret. “We invented it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You invented your own mystery game?” he said, shaking his head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ve tried playing Clue, but Florian wins it too quickly,” she answered. “So we had to come up with something more complicated.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s good,” I added. “But it’s still got a few kinks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s only saying that because he’s losing,” she retorted. “He doesn’t know what I know, that the moon rock was stolen by George Washington, who hid it in the House of Representatives.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She stood up and delivered a triumphant “Boom!” before doing a victory dance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I let her have a moment of glory before breaking the bad news. “Sorry, but George couldn’t have done it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course he did,” she said as she started listing off clues from her pad. “It was stolen by a president, from Virginia, who—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Was short,” I interrupted, showing her an Evidence card. “George was six foot two.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("She sat down and stared at the card, shaking her head in disbelief.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“How’d I miss that?” she muttered, rechecking her notes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I gleefully snatched the dice off the board and was about to roll when I noticed something and stopped abruptly. “Let’s call it a draw,” I suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why would I agree to that?” asked Margaret. “I’m about to—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because Marcus is here to talk about a real mystery,” I interrupted. “And those are way more fun than fake ones.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She turned to look at him more closely and her eyes opened wide with anticipation. “Deal. It’s a draw.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whoa, whoa, whoa,” Marcus said. “How do you know I’m not just paying a friendly visit? What makes you think I’m here on business?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your shoes,” I answered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And your belt,” added Margaret. “We could go on if you’d like.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s wrong with my shoes and belt?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Even though it’s Saturday afternoon, you’re wearing dark dress shoes with rubber soles and a belt thick enough for a holster and walkie-talkie,” I pointed out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That means you’re on duty,” explained Margaret. “And if you’re on duty and you come by here . . .”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("“That means you want to talk about a case,” I finished.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Margaret and I shared a low-key but confident fist bump. (Elbow high, no eye contact, no blowing up.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He laughed. “Okay, I guess you guys are pretty smart.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And this is where Margaret went a bit too far by boasting, “Can’t get anything by us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is that so?” he asked. “Then how come neither one of you knew that James Madison stole the moon rock?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It took a second to realize he was talking about the game and another to see that he was probably right. I opened the case file and shook my head when I read the solution.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How could you possibly know that?” I asked, stunned. “You’ve never even seen the game before.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcus flashed a playful grin. “There were eight presidents from Virginia. Five were tall, two were average height, but James Madison was five foot four. He’s the only suspect who fits your profile.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You memorized the heights of the presidents?” Margaret asked in disbelief.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He winked at her and whispered, “Boom.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We went upstairs to the living room, where Dad was riveted by the Notre Dame football game. After a brief negotiation with my mom, he muted the "), _c('span', {
    staticClass: "allcaps"
  }, [_vm._v("TV")]), _vm._v(" and we all listened as Marcus explained the particulars of the case.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("“First of all, I apologize for interrupting your weekend,” he said. “But we’ve got a situation that we need to move on quickly.”")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“What is it?” I asked, tingling with excitement. “Bank robbery? Counterfeit ring? Please tell me it’s international espionage. That’s my favorite.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Middle school pranks,” he answered, completely deflating the moment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh,” I said, slumping.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Two weeks ago some lockers were vandalized at Chatham Country Day School,” he continued. “Then last week someone hacked into the school e-mail server and crashed the whole system.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I waited for more, but that was it. “I’m confused,” I said. “What do you want us to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Go undercover and figure out who’s behind it,” he answered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I really wanted to sound enthusiastic, but it seemed so very . . . small.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why does the "), _c('span', {
    staticClass: "allcaps"
  }, [_vm._v("FBI")]), _vm._v(" even care?” I asked. “Shouldn’t this be handled by the principal or a dean?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Normally, but . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('span', {
    staticClass: "allcaps"
  }, [_vm._v("CCD")]), _vm._v(" is anything but normal,” interjected Margaret.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Exactly,” he said.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("I turned to her, still confused.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Chatham Country Day is the most prestigious prep school in the District,” she explained. “Its student body includes the children of some very powerful people.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Including Lucy Mays,” Marcus added.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You mean the Lucy Mays who’s the president’s daughter?” I asked as I began to grasp the magnitude of the situation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The one and only,” he said. “To make matters worse, she’s at least circumstantially connected to both pranks. We don’t know if she’s the target, an innocent bystander, or maybe even the perpetrator. But whatever’s going on has to stop before it escalates and turns into something newsworthy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes! Yes! Yes!” exclaimed my father.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I thought it was a pretty enthusiastic response. Then I noticed that Notre Dame had just scored a touchdown and realized he was reacting to that, not the conversation. Mom gave him a dirty look and he sheepishly turned off the television.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All three of Admiral Douglas’s children went to Chatham,” Marcus said, referring to the director of the "), _c('span', {
    staticClass: "allcaps"
  }, [_vm._v("FBI")]), _vm._v(". “So the headmaster called him directly and asked for help as a personal favor.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("“What about the Secret Service?” Mom asked. “Aren’t they supposed to be with the first family at all times? Can’t they tell you what’s happening?”")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s true they’re always with her,” answered Marcus. “But they can’t help us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Even if they know, they wouldn’t tell,” added my dad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcus nodded. “That’s right. Their sole job is to protect her. If they turned her in every time she did something wrong, she’d try to hide from them, which would jeopardize her safety. The Secret Service is well named. They keep secrets.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So, I’m still a little unsure how we fit into this,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“With the children of so many powerful people at the school, if there was a hint that the "), _c('span', {
    staticClass: "allcaps"
  }, [_vm._v("FBI")]), _vm._v(" was investigating, it would become an instant scandal,” he answered. “So the admiral thought the perfect solution would be for you two to go undercover and figure it out. Once you give us the information, we’ll pass it along to the school and they’ll handle everything. Low-key. No news reporters.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So we’re going to pretend to be students at Chatham?” asked Margaret. “Of all the places . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why do you say that?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because I hate them,” she said. “I play a lot of those girls in soccer. They’re all stuck-up and mean.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("“All of them?” ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("I asked. “Think you might be exaggerating just a bit?”")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I haven’t met each one individually,” she said only half jokingly. “But I still feel pretty confident in my assessment.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How long will this take?” asked Mom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hopefully just a week or two,” said Marcus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s a lot of school to miss,” she replied. “Remember the policy we agreed on with Admiral Douglas. Florian can help save the country, but not if it hurts his academics. He can’t miss that many days.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s the best part,” Marcus informed her. “They have an International Baccalaureate program just like the one at Deal Middle School. The schoolwork will transfer back and forth. These two will hardly miss a thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Great,” I said sarcastically. “I’d hate to miss any homework.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, I just remembered something,” Margaret said. “I may have a conflict. I have to be at Deal Thursday after school.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Since when?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looked a little embarrassed as she answered, “Since I signed up to audition for the school talent show.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I couldn’t believe it. “How is this the first I’m hearing about this?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("“I was waiting to see if I got picked,” she said. “I thought I’d surprise you.”")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll make sure you get to the audition,” promised Marcus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then I’m in,” answered Margaret.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Me too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But if any of those girls gives me attitude,” she added, “I’m giving it right back to them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcus laughed. “I’d expect nothing less.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c60927b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 69
// module chunks = 0